module.exports = "/images/genius_logo_dark.svg?9c3f017f1a2898b1ad498b18c97403f9";